// extracted by mini-css-extract-plugin
module.exports = {"regular":"_93444fe79c--regular--20Y41","accent":"_93444fe79c--accent--1CCBu","warn":"_93444fe79c--warn--1Gky1"};